import { apiGet, apiPut, throwApiError } from "../utils";

const handleAuthError = (response) => {
  if (response.status === 401 || response.status === 403) {
    window.location.href = "/login";
    throw new Error("Unauthorized");
  }
};

export const getRewards = async (
  page,
  perPage,
  search = "",
  queryParams = {},
) => {
  const params = { page, perPage, ...queryParams };
  if (search) {
    params.search = search;
  }
  const response = await apiGet("/rewards", params);
  const data = await response.json().catch(() => ({}));

  handleAuthError(response);

  if (!response.ok) {
    throwApiError(data?.message);
    throw new Error(data?.message || "Failed to load rewards");
  }

  throwApiError(data?.message);
  return { items: data?.items ?? [], totalCount: data?.totalCount ?? 0 };
};

export const getRewardsConfig = async () => {
  const response = await apiGet("/rewards/config");
  const data = await response.json().catch(() => ({}));

  handleAuthError(response);

  if (!response.ok) {
    throwApiError(data?.message);
    throw new Error(data?.message || "Failed to load rewards config");
  }

  throwApiError(data?.message);
  return data;
};

export const updateAppOpenedStreakConfig = async (body) => {
  const response = await apiPut("/rewards/config/app-opened-streak", body);
  const data = await response.json().catch(() => ({}));

  handleAuthError(response);

  if (!response.ok) {
    if (response.status === 400 && data?.errors) {
      const err = new Error(data?.message || "Validation failed");
      err.status = 400;
      err.errors = data.errors;
      throw err;
    }
    throwApiError(data?.message);
    throw new Error(data?.message || "Failed to update config");
  }

  throwApiError(data?.message);
  return data;
};

export const updateShowsHostedConfig = async (body) => {
  const response = await apiPut("/rewards/config/shows-hosted", body);
  const data = await response.json().catch(() => ({}));

  handleAuthError(response);

  if (!response.ok) {
    if (response.status === 400 && data?.errors) {
      const err = new Error(data?.message || "Validation failed");
      err.status = 400;
      err.errors = data.errors;
      throw err;
    }
    throwApiError(data?.message);
    throw new Error(data?.message || "Failed to update config");
  }

  throwApiError(data?.message);
  return data;
};
